export default "__VITE_ASSET__18728023__"